var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9227 17.3132C23.9669 17.3816 23.9917 17.4608 23.9945 17.5422C23.9972 17.6236 23.9779 17.7042 23.9384 17.7755C23.899 17.8467 23.8409 17.9059 23.7704 17.9468C23.7 17.9877 23.6197 18.0086 23.5383 18.0074H1.40625V3.17995H23.5416C23.6013 3.17945 23.6605 3.19072 23.7159 3.21312C23.7712 3.23551 23.8216 3.26859 23.8642 3.31047C23.9067 3.35234 23.9407 3.40219 23.964 3.45717C23.9873 3.51214 23.9995 3.57117 24 3.63088C23.9998 3.71692 23.9744 3.80101 23.9269 3.87276L23.0733 5.18526L21.1594 8.12432L21.0717 8.25885L21.0131 8.34885L20.9836 8.39573L20.625 8.94229L20.617 8.96714H20.6091L20.3241 9.40495L20.3058 9.4326L20.2552 9.50995L20.0527 9.8212L19.5323 10.6181L20.0212 11.3634L20.2758 11.752L20.9888 12.8381L21.1359 13.0626L23.0733 16.0157L23.9227 17.3132Z",
    fill: "#008751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95221 3.17993H16.4541V18.007H8.95221V3.17993Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1942 2.14464C2.1942 1.72214 1.85181 1.37964 1.42944 1.37964C1.00707 1.37964 0.664673 1.72214 0.664673 2.14464V23.2351C0.664673 23.6576 1.00707 24.0001 1.42944 24.0001C1.85181 24.0001 2.1942 23.6576 2.1942 23.2351V2.14464Z",
    fill: "url(#paint0_linear_264_3187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42969 2.85938C2.21928 2.85938 2.85938 2.21928 2.85938 1.42969C2.85938 0.640093 2.21928 0 1.42969 0C0.640093 0 0 0.640093 0 1.42969C0 2.21928 0.640093 2.85938 1.42969 2.85938Z",
    fill: "url(#paint1_linear_264_3187)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_3187",
    x1: 0.664673,
    y1: 12.6896,
    x2: 2.19467,
    y2: 12.6896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECCCA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F2CA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5BB88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C2945B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F6C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_3187",
    x1: 0,
    y1: 1.42969,
    x2: 2.85938,
    y2: 1.42969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FD4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EC432A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#810001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_3187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.917159923bc4f8daf3f22bbbe58babaa.svg";
export { ForwardRef as ReactComponent };